import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import { AgGridReact } from 'ag-grid-react';
import React, { Component } from 'react';
import './grid.scss';

class Grid extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`ag-theme-balham ag-grid-main ${this.props.parent}`}>
        <AgGridReact {...this.props.gridOptions}></AgGridReact>
      </div>
    );
  }
}
export default Grid;
